module.exports = __webpack_public_path__ + "media/sind-die-lichter.3a4e284b.mp3";